import axios from "axios"
import bcrypt from "bcryptjs"

const login = (context, data) => {
  context.commit("SET_CURRENT_USER", {
    user: data,
    token: token
  })
}

const logout = (context, vm) => {
  context.commit("DELETE_CURRENT_USER")
  localStorage.removeItem("__crrntUser")
  vm.$router.push("/auth/no/login")
}

const updateUserState = (context, vm) => {
  let user = localStorage.getItem("__crrntUser")

  if (user) {
    axios({
      method: "get",
      url: vm.API_URL + "auth/user"
    })
      .then((res) => {
        context.commit("SET_CURRENT_USER", {
          user: res.data.data,
          token: token
        })
      })
      .catch((err) => {
        return false
      })
  }
}

const hasPinCode = (context) => {
  let pinObj = localStorage.getItem("__userPin")
  return pinObj ? true : false
}

const getPinCode = (context) => {
  let pinObj = localStorage.getItem("__userPin")
  return pinObj ? JSON.parse(pinObj) : null
}

const setPinCode = (context, data) => {
  if (data.userid && data.pin) {
    bcrypt.hash(data.pin, 6, (err, hash) => {
      if (hash) {
        let pinObj = {
          hash: hash,
          userid: data.userid,
          login_via_pin: data.login_via_pin
        }

        localStorage.setItem("__userPin", JSON.stringify(pinObj))
      }
    })
  }
}

export default {
  login,
  logout,
  updateUserState,
  setPinCode,
  getPinCode,
  hasPinCode
}
